const getMaNavigation = (state: any) => state.maNavigation;
export const getNotificationsLink = (state: any) => getMaNavigation(state).notificationsLink;
